module.exports = __webpack_public_path__ + "img/dc.497f9e22.svg";